/**
 * Update Image loop component
 *
 * @param {HTMLElement} imageList Image loop container
 * @returns
 */
const updateImageLoop = (imageList) => {
  if (!imageList) return;
  const imageLoop = imageList.querySelector('ul');
  if (!imageLoop) return;

  // Clean previous loop
  imageLoop.style.animationDuration = '';
  const duplicates = Array.from(imageLoop.getElementsByClassName('duplicate'));
  duplicates.forEach((item) => item.remove());

  if (imageList.clientWidth >= imageLoop.clientWidth) return;

  const images = Array.from(imageLoop.getElementsByTagName('li'));
  images.forEach((image) => {
    const prevClone = image.cloneNode(true);
    prevClone.classList.add('duplicate');
    const prevCloneLink = prevClone.querySelector('a');
    if (prevCloneLink) {
      prevCloneLink.tabIndex = -1;
    }
    imageLoop.insertBefore(prevClone, images[0]);

    const nextClone = image.cloneNode(true);
    nextClone.classList.add('duplicate');
    const nextCloneLink = nextClone.querySelector('a');
    if (nextCloneLink) {
      nextCloneLink.tabIndex = -1;
    }
    imageLoop.appendChild(nextClone);
  });

  images.forEach((image) => {
    const link = image.querySelector('a');
    if (link) {
      link.addEventListener('blur', () => {
        imageLoop.classList.add('anim-slide');
      });
    }
  });

  imageLoop.style.animationDuration = `${images.length * 5}s`;
  imageLoop.classList.add('anim-slide');
};

const imageList = document.querySelector('.js-image-loop .item-list');
updateImageLoop(imageList);

window.addEventListener('resize', () => {
  updateImageLoop(imageList);
});
